import React from "react";
import Box from "@material-ui/core/Box";
import LoadingIcon from "@material-ui/icons/Autorenew";
import { withStyles } from "@material-ui/core/styles";

const styles = theme => ({
    icon: {
        fontSize: theme.typography.fontSize * 10,
        animationDuration: "2s",
        animationIterationCount: "infinite",
        animationName: "$spin",
    },
    "@keyframes spin": {
        "0%": {
            transform: "rotate(0deg)",
        },
        "100%": {
            transform: "rotate(360deg)",
        },
    },
});

const LoadingScreen = ({ classes }) => (
    <Box display="flex" justifyContent="center" alignItems="center" px={5.25}>
        <Box width="100%">
            <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
                <Box mt={8} mb={3}>
                    <LoadingIcon color="disabled" classes={{ root: classes.icon }} />
                </Box>
            </Box>
        </Box>
    </Box>
);

export default withStyles(styles)(LoadingScreen);
